// extracted by mini-css-extract-plugin
module.exports = {"ContactSelectionButton":"ContactPersons_ContactSelectionButton__20VYu"};